import React, {useMemo} from "react";
import {LockOutlined, WarningOutlined} from "@ant-design/icons";
import {Button, Modal, Row} from "antd";
import {PadlockIcon} from "@components/icons/HomePageIcons";


const HomePageLists = ({windowDimensions, allowPremium, listItems}) => {
    const itemsPerRow = useMemo(() => {
        //Large screens
        let itemsPerRow = 6;
        if(windowDimensions.under(1440)) itemsPerRow = 5;
        //Medium screens
        if(windowDimensions.under(1261)) itemsPerRow = 8;
        if(windowDimensions.under(1120)) itemsPerRow = 7;
        if(windowDimensions.under(1000)) itemsPerRow = 6;
        if(windowDimensions.under(860)) itemsPerRow = 5;
        //SMall screens
        if(windowDimensions.under(800)) itemsPerRow = 6;
        if(windowDimensions.under(690)) itemsPerRow = 5;
        if(windowDimensions.under(580)) itemsPerRow = 4;
        if(windowDimensions.under(455)) itemsPerRow = 3;
        return itemsPerRow;
    }, [windowDimensions]);

    const itemWidth = useMemo(() => {
        const newWidth = Math.floor(100/itemsPerRow)-1;
        return newWidth+'%';
    }   , [itemsPerRow]);

    const listItemsShown = useMemo(() => {
        if(listItems){
            //pad item row to keep spacing even.
            const leftover = itemsPerRow - (listItems.length % itemsPerRow);
            const fill = Array(leftover).fill(false);
            return (leftover > 0 && leftover < itemsPerRow) ? [...listItems, ...fill] : [...listItems];
        }

        return [];
    }, [listItems, itemsPerRow]);

    const showUpgradeModal = () => {
        Modal.confirm({
            autoFocusButton: null,
            icon: <WarningOutlined />,
            content: (
                <div>
                    <div><b>Upgrade Now!</b></div>
                    <div className="pad-top-10">
                        Sorry, this content is only available to premium members.<br/>
                        Please upgrade now for this and many other benefits.<br/>
                    </div>
                </div>
            ),
            okText: "UPGRADE",
            onOk() {
                window.location.href = "/plans/unlimited/";
            },
        });
    };

    return (
        <div className="homepage-lists">
            <h2 >Explore & Discover</h2>
            <div className="lists-grid">
                {listItemsShown.map((item,i) => !allowPremium && item.premium ? (
                    <div
                        key={i}
                        style={{width: itemWidth}}
                    >
                        <div
                            className={"list-item " + (!item ? 'filler' : '')}
                            style={{backgroundImage: `url(${item.image})`}}
                            onClick={showUpgradeModal}
                        >
                            <div className="list-item-inner">
                            </div>
                            <PadlockIcon className="whiteCircleIconTiny"
                                         style={{position: 'absolute', top: "5%", right: "5%"}}/>
                        </div>
                        <div className={"list-item-text"}>
                            <div className={"homepage-item-title mar-top-5"}>{item.title}</div>
                            <div className={"homepage-item-subtitle"}>{item.subtitle}</div>
                        </div>
                    </div>
                ) : (
                    <div
                        key={i}
                        style={{width: itemWidth}}
                    >
                        <a href={item.link_url}>
                            <div
                                className={"list-item " + (!item ? 'filler' : '')}
                                style={{backgroundImage: `url(${item.image})`}}
                            >
                                <div className="list-item-inner">
                                </div>
                            </div>
                        </a>
                        <div className={"list-item-text"}>
                            <div className={"homepage-item-title mar-top-5"}>{item.title}</div>
                            <div className={"homepage-item-subtitle mar-bot-10"}>{item.subtitle}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HomePageLists;